import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-xs text-slate-600 font-medium tabular-nums shrink-0"
}
const _hoisted_2 = ["id", "aria-checked", "disabled"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminToggleSwitch',
  props: {
    modelValue: { type: Boolean },
    label: {},
    labelPosition: { default: "top" },
    color: { default: "red" },
    trackOnClass: {},
    trackOffClass: {},
    focusRingClass: {},
    disabled: { type: Boolean, default: false },
    size: { default: "sm" },
    showStateText: { type: Boolean, default: false },
    onText: { default: "Visible" },
    offText: { default: "Oculto" },
    switchId: { default: "admin-toggle" }
  },
  emits: ["update:modelValue", "toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeTrack = computed(() => {
  if (props.trackOnClass) {
    return props.trackOnClass;
  }
  const map: Record<string, string> = {
    blue: "bg-blue-600",
    red: "bg-red-600",
    emerald: "bg-emerald-600",
    violet: "bg-violet-600",
    slate: "bg-slate-600",
  };
  return map[props.color] ?? map.blue;
});

const inactiveTrack = computed(
  () => props.trackOffClass || "bg-slate-200"
);

const ring = computed(
  () =>
    props.focusRingClass ||
    (props.color === "red"
      ? "focus-visible:ring-red-500"
      : "focus-visible:ring-blue-500")
);

const dimensions = computed(() =>
  props.size === "md"
    ? { track: "h-7 w-12", thumb: "h-6 w-6", translate: "translate-x-5" }
    : { track: "h-6 w-11", thumb: "h-5 w-5", translate: "translate-x-5" }
);

const onClick = () => {
  if (props.disabled) return;
  const next = !props.modelValue;
  emit("update:modelValue", next);
  emit("toggle");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["min-w-0", 
      __props.labelPosition === 'left'
        ? 'flex flex-row items-center gap-3'
        : 'flex flex-col gap-1.5'
    ])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["text-xs font-bold text-slate-600 uppercase tracking-wide shrink-0", __props.labelPosition === 'left' ? 'pt-0.5' : ''])
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center gap-2 min-w-0", __props.labelPosition === 'left' ? 'flex-1 justify-end' : ''])
    }, [
      (__props.showStateText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.modelValue ? __props.onText : __props.offText), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        id: __props.switchId,
        type: "button",
        role: "switch",
        "aria-checked": __props.modelValue,
        disabled: __props.disabled,
        class: _normalizeClass([
          'relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
          dimensions.value.track,
          __props.modelValue ? activeTrack.value : inactiveTrack.value,
          ring.value,
          __props.disabled ? 'opacity-50 cursor-not-allowed' : '',
        ]),
        onClick: onClick
      }, [
        _createElementVNode("span", {
          "aria-hidden": "true",
          class: _normalizeClass([
            'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-out',
            dimensions.value.thumb,
            __props.modelValue ? dimensions.value.translate : 'translate-x-0',
          ])
        }, null, 2)
      ], 10, _hoisted_2)
    ], 2)
  ], 2))
}
}

})